export default "__VITE_ASSET__CEsa1T9n__"